import clsx from 'clsx';
import React from 'react';

var TUXTextWIP = function TUXTextWIP(_ref) {
  var type = _ref.type,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    className: clsx(type, className)
  }, children);
};

export { TUXTextWIP };
//# sourceMappingURL=TUXText.js.map
